import React, { useEffect, useState } from "react";
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer } from "recharts";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/Layout";
import { Card } from "@/components/ModulePage";

export default function Maturity() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/maturity").then(({ data }) => setRows(data)).catch(() => {}).finally(() => setLoading(false)); }, []);
  const chart = rows.map((r) => ({ dimension: r.dimension, current: r.current_level, target: r.target_level }));
  const raCtx = "AI maturity assessment across ten dimensions. " + rows.map((r) => `${r.dimension} at level ${r.current_level} of ${r.target_level}`).join(", ") + ". Dimensions are shown separately to avoid a single misleading score.";

  if (loading) return <div className="flex justify-center py-20"><Loader2 className="h-6 w-6 animate-spin text-accent" /></div>;
  return (
    <div>
      <PageHeader title="Enterprise AI Maturity" subtitle="Levels 1–5 shown per dimension (People, Process, Technology, Data, Security, Governance, Compliance, Audit, Operations, AI) — never collapsed into one score." readAloudContext={raCtx} />
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <Card testId="maturity-radar">
          <h3 className="mb-3 text-sm font-semibold">Maturity Radar (current vs target)</h3>
          <ResponsiveContainer width="100%" height={340}>
            <RadarChart data={chart}>
              <PolarGrid stroke="hsl(var(--border))" />
              <PolarAngleAxis dataKey="dimension" tick={{ fontSize: 10, fill: "hsl(var(--muted-foreground))" }} />
              <PolarRadiusAxis domain={[0, 5]} tick={{ fontSize: 9 }} />
              <Radar name="Current" dataKey="current" stroke="hsl(var(--chart-1))" fill="hsl(var(--chart-1))" fillOpacity={0.5} />
              <Radar name="Target" dataKey="target" stroke="hsl(var(--chart-2))" fill="hsl(var(--chart-2))" fillOpacity={0.15} />
            </RadarChart>
          </ResponsiveContainer>
        </Card>
        <Card>
          <h3 className="mb-3 text-sm font-semibold">Dimension Detail</h3>
          <div className="space-y-2">
            {rows.map((r) => (
              <div key={r.dimension} className="rounded-xl border border-border bg-secondary/20 p-3">
                <div className="mb-1 flex items-center justify-between text-sm"><span className="font-medium">{r.dimension}</span><span className="rounded-md border border-border px-2 py-0.5 text-xs font-semibold">Level {r.current_level} / {r.target_level}</span></div>
                <div className="flex gap-1">
                  {[1, 2, 3, 4, 5].map((l) => <div key={l} className={`h-2 flex-1 rounded-full ${l <= r.current_level ? "bg-accent" : "bg-secondary"}`} />)}
                </div>
                <div className="mt-1 text-[11px] text-muted-foreground">{r.level_name}</div>
              </div>
            ))}
          </div>
        </Card>
      </div>
    </div>
  );
}
